import LazyLoadImagesHelper from '@/helpers/global/lazyLoadImages.helper';

class AccordionsHelper {
  initAccordionsLogic() {
    const accordionsList = document.querySelectorAll('.row.cb-accordion');

    accordionsList.forEach((accordion) => {
      const accordionHeader = accordion.querySelector('.cb-accordion-header');
      const accordionBody = accordion.querySelector('.cb-accordion-body');
      accordionHeader.addEventListener('click', () => {
        if (accordionHeader.classList.contains('active')) {
          accordionHeader.classList.remove('active');
          accordionBody.classList.remove('active');
          accordionBody.style.height = '0px';
        } else {
          const openAccordion = () => {
            accordionHeader.classList.remove('loading');

            accordionHeader.classList.add('active');
            accordionBody.classList.add('active');
            const accordionBodyHeight = accordionBody.querySelector('.cb-accordion-body-content').clientHeight;
            accordionBody.style.height = `${accordionBodyHeight + 2}px`;
          };

          accordionHeader.classList.add('loading');

          let checkAccordionBodyInterval = null;

          const accordionBodyImages = accordionBody.querySelectorAll('img.lazy');
          let accordionBodyImagesLoaded = accordionBody.querySelectorAll('img.lazy.loaded');

          if (accordionBodyImages.length !== accordionBodyImagesLoaded.length) {
            if (accordionBodyImages.length > 0) {
              accordionBodyImages.forEach((image: HTMLElement) => {
                LazyLoadImagesHelper.loadImagesInElement(image);
              });
            }

            checkAccordionBodyInterval = setInterval(() => {
              accordionBodyImagesLoaded = accordionBody.querySelectorAll('img.lazy.loaded');

              if (accordionBodyImages.length === accordionBodyImagesLoaded.length) {
                clearInterval(checkAccordionBodyInterval);
                openAccordion();
              }
            }, 100);
          } else {
            openAccordion();
          }
        }
      });
    });
  }
}

export default new AccordionsHelper();
